import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarriersForAssignment extends Layout {
    sourceCarriersForAssignment: DataSource;
    tableCarriersForAssignment: Table;
}
